import { LayoutServicePageState, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { SitecoreContextValue } from 'lib/ComponentProps';

export default function IsSitecoreEditing(): boolean {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	return sitecoreContext?.pageEditing && sitecoreContext?.pageState
		? sitecoreContext.pageEditing && sitecoreContext.pageState !== LayoutServicePageState.Normal
		: false;
}
